import { Editor, Transforms, type Selection as SlateSelection } from 'slate';

class SelectionUtils {
  static selectAll(editor: Editor) {
    Transforms.select(editor, {
      anchor: Editor.start(editor, []),
      focus: Editor.end(editor, []),
    });
  }

  static moveToStart(editor: Editor) {
    Transforms.select(editor, {
      anchor: Editor.start(editor, []),
      focus: Editor.start(editor, []),
    });
  }

  static moveToEnd(editor: Editor) {
    Transforms.select(editor, {
      anchor: Editor.end(editor, []),
      focus: Editor.end(editor, []),
    });
  }

  static moveAfterCurrentNode(editor: Editor) {
    const { selection } = editor;
    if (!selection) return;

    const [, path] = Editor.parent(editor, selection.focus.path);
    const point = Editor.after(editor, path);
    if (point) {
      Transforms.select(editor, {
        anchor: point,
        focus: point,
      });
    }
  }

  static select(editor: Editor, selection: SlateSelection) {
    if (!selection) return;

    Transforms.select(editor, selection);
  }
}

export default SelectionUtils;
